/**
* Horizontal Project Scroll JS
* -----------------------------------------------------------------------------
*
* All the JS for the Horizontal Project Scroll component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'horizontal-project-scroll',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const xPx = $( '.horizontal-project-scroll__inner' )[0].scrollWidth;
      gsap.to( '.horizontal-project-scroll__inner', {
        x: ( ( xPx - window.innerWidth ) * -1 ),
        ease: 'none',
        scrollTrigger: {
          trigger: '.horizontal-project-scroll__desktop',
          pin: true,
          pinSpacing: true,
          scrub: 1,
          end: '+=3000',
          // markers: true,
        },
      } );

      $( '.horizontal-project-scroll__desktop .fit-image' ).each( function( key, image ) {
        const scrollWidth = $( '.horizontal-project-scroll__inner' )[0].scrollWidth;
        const left = ( $( image ).offset().left );
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: left + 'px 50%',
            end: '+=' + window.innerWidth + 'px',
            scrub: 2,
            // markers: true,
          },
        } );
        tl.to( image, {x: '-20%', ease: 'linear'}, 0 );
      } );

      // Link Cursor
      const zone = $( '.horizontal-project-scroll .cursor-zone' )[0];
      const cursor = $( '.horizontal-project-scroll .custom-cursor' )[0];
      const innerCursor = $( '.horizontal-project-scroll .custom-cursor__inner' )[0];

      let x = 0;
      let y = 0;
      let active = false;
      let escaped = false;

      zone.addEventListener( 'mouseenter', () => {
        active = true;
        cursor.style.opacity = 1;
        innerCursor.style.transform = `scale(1)`;
      } );

      zone.addEventListener( 'mouseleave', () => {
        active = false;
        escaped = false;
        zone.style.cursor = 'auto';
        innerCursor.style.transform = `scale(0)`;

        setTimeout( function() {
          cursor.style.opacity = 0;
        }, 200 );
      } );

      // Track mouse ONLY relative to the zone
      zone.addEventListener( 'mousemove', ( e ) => {
        const rect = zone.getBoundingClientRect();

        x = e.clientX - rect.left;
        y = e.clientY - rect.top;

        // Escape hatch check
        const escapeTarget = e.target.closest( '.native-cursor' );

        if ( escapeTarget ) {
          escaped = true;
          zone.style.cursor = 'auto';
          cursor.style.opacity = 0;
        } else {
          escaped = false;
          cursor.style.opacity = 1;
          zone.style.cursor = 'none';
        }

        if ( active && !escaped ) {
          const maxRotation = 25;
          const vw = window.innerWidth;
          const rotateAmount = -maxRotation + ( x / vw ) * ( maxRotation * 2 );

          cursor.style.transform =
          `translate(${x}px, ${y}px) translate(-50%, -50%) rotate( ${rotateAmount}deg )`;
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'horizontal-project-scroll', COMPONENT );
} )( app );
